import SwishMatchMarketPropsModel from "./swish-match-market-props-model";

export default class SwishBetBuilderRequestModel {
  constructor(data, match) {
    /**
     * Parlay
     * @type {boolean}
     */
    this.pa = true;
    /**
     * Bet request
     */
    this.bre = [];
    this.bre.push({
      sfm: {
        t: match.swTournamentName.toLowerCase(),
        h: match.swHomeTeamID,
        a: match.swAwayTeamID,
        m: match.swMatchId,
        sm: match.swSwishMatchID
      }
    })
    const selections = data.map(x => new SwishMatchMarketPropsModel(x));
    const playerPropsMarkets = selections.filter(x => x.mpid);
    const preMatchMarkets = selections.filter(y => y.mmid);

    if (playerPropsMarkets.length > 0) {
      this.bre[0].mpp = playerPropsMarkets;
    }
    if (preMatchMarkets.length > 0) {
      this.bre[0].pmm = preMatchMarkets;
    }
  }
}